/**
 * Shape returned by every tile endpoint. The proxy is responsible for collapsing
 * the verbose NextX response into this small payload, so the SPA stays dumb.
 */
export interface TileMetric {
  /** Total number of items currently in this state. */
  count: number;
  /** Items in this state for between 24 and 48 hours. Drives the amber chip. */
  count_24h: number;
  /** Items in this state for over 48 hours. Drives the red chip. */
  count_48h: number;
  /** ISO timestamp when the proxy last fetched this metric. */
  fetched_at: string;
  /** Deep-link to the equivalent filtered list inside go.nextx.com.au. */
  link: string;
}

export interface TileError {
  error: string;
  fetched_at: string;
}

export type TileResponse = TileMetric | TileError;

export function isTileError(r: TileResponse): r is TileError {
  return (r as TileError).error !== undefined;
}
